import { httpRequest, endpoint } from "@cirrus/core/http"

// TODO: Delete if not used
export const getCandidateReviewData = async (params) =>
  await httpRequest.get(endpoint.withRoot("/api/v1/author/marking/review-sessions"), { params })
